import React from 'react';
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  useMediaQuery
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

export default function ReportDataGridModal({ title = 'Report', open, onClose, reportData = null, reportDataGrid = null }) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md')); // md = 960px+

  const handleClose = () => {
    onClose();
  };  

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      disableRestoreFocus
      fullWidth
      maxWidth={false} // disable the default maxWidth constraint
      PaperProps={{
        sx: {
          width: { xs: '100%', md: '90%' }, // 90% on desktop, full width on mobile
          maxWidth: 'none',                 // critical: removes the 600px ceiling
          maxHeight: '90vh',                // optional: keep it from overflowing vertically
          margin: 'auto',                   // centers the dialog
          borderRadius: 2                   // optional: rounded corners
        },
      }}
    >
      <DialogTitle>
        {title}
      </DialogTitle>
      <DialogContent>
        {reportData ? (
          reportDataGrid
        ) : null}
      </DialogContent>
      <DialogActions>
        <div style={{ flex: '1 0 0' }} />
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
